import { Common } from './Common';

export class Address extends Common {

    address: string;
    colony: string;
    area: string;
    lane: string;
    town: string;
    city: string;
    district: string;
    state: string;
    country: string;
    pincode: string;
    phone: string;
    landmark: string;
    floor: string;
    tower: string;
    society: string;
    ref_id: string;
    ref_type: string;
    type: string;
    category: string;
    time: number;
}